export default __webpack_public_path__ + "static/media/ol-logo.103b98cd.png";